module.exports = __webpack_public_path__ + "img/graph_FR.88067f24.jpg";